module.exports = __webpack_public_path__ + "static/img/download_account_mobile.dd1054c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/download_account_mobile.png
// module id = E0lI
// module chunks = 8